// extracted by mini-css-extract-plugin
export default {"dataTableFormat":"styles_dataTableFormat__wkYvK","formSpace":"styles_formSpace__vPBDO"};